import moment from "moment";
import React, { useEffect, useState } from "react";
import { IoAlertCircle, IoExpandOutline } from "react-icons/io5";
import { APi } from "../../Api";
import Calendar from "../../Components/Calendar/calendar";
import ListJournal from "./ListJournal";
import ListTransactions from "./ListTransactions";
import { userAtom } from "../../Atoms/user.atom";
import { useRecoilValue } from "recoil";
import Translation from "../../translation/translation";
import { Notification, toaster } from "rsuite";

export default function JournalCheckout(props) {
  const [date, setdate] = useState(new Date());
  const [monthlyJournal, setmonthlyJournal] = useState([]);
  const user = useRecoilValue(userAtom);

  const [loading, setloading] = useState(false);
  const [checkouts, setcheckouts] = useState([]);
  const [transactions, settransactions] = useState([]);
  const fetchCheckouts = (q = "") => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Checkout, { q, take: 100 })
      .customGet()
      .then((res) => setcheckouts(res.data.data));
  };
  const fetchJournals = (_monthYear) => {
    APi.createAPIEndpoint(APi.ENDPOINTS.JournalCheckout + "/getByMonth", {
      ..._monthYear,
      checkoutId: user ? props.checkoutId : 0,
    })
      .customGet()
      .then((res) => setmonthlyJournal(res.data.data));
  };
  const fetchTransactions = (d) => {
    let _date = moment(date).date(d);
    //   (d > 9 ? d : "0" + d) +
    //   "-" +
    //   (moment(date).month() + 1) +
    //   "-" +
    //   moment(date).year();
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction, {
      date: _date.format("yyyy-MM-DD"),
      take: 1000,
      checkoutId: user ? props.checkoutId : 0,
    })
      .customGet()
      .then((res) => settransactions(res.data.data));
  };
  const [monthYear, setmonthYear] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });
  const [show, setshow] = useState(0);
  const [showCheckouts, setshowCheckouts] = useState(0);
  useEffect(() => {
    fetchCheckouts();
    fetchJournals({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
    });
    return () => {};
  }, []);
  const verify = () => {
    let _date = moment(date).date(show);

    APi.createAPIEndpoint(APi.ENDPOINTS.JournalCheckout)
      .create({
        date: _date.format("yyyy-MM-DD"),
        checkoutId: user ? props.checkoutId : 0,
        verified: true,
      })
      .then((res) => {
        fetchJournals(monthYear);

        setshow(0);
      })
      .catch((error) => {
        toaster.push(
          <Notification type="error" header={Translation.errorHeader} closable>
            {error?.response?.data?.title ||
              error?.response?.data?.message ||
              Translation.error}
          </Notification>,
          { placement: "topEnd" }
        );
      });
  };
  return (
    <div>
      <Calendar
        selectMonth={(date) => {
          //  alert(JSON.stringify({ month: date.month() + 1, year: date.year() }));
          setmonthYear({ month: date.month() + 1, year: date.year() });
          fetchJournals({ month: date.month() + 1, year: date.year() });
        }}
        onChange={setdate}
        customCell={(d) => (
          <div
            style={{
              position: "relative",
              textAlign: "center",
              border: monthlyJournal.find(
                (el) =>
                  moment(el.date).date() == d &&
                  moment(el.date).year() == monthYear.year &&
                  moment(el.date).month() + 1 == monthYear.month
              )
                ? "1px solid rgb(0,169,141)"
                : "1px solid #eee",
              padding: "10px",
              background: monthlyJournal.find(
                (el) =>
                  moment(el.date).date() == d &&
                  moment(el.date).year() == monthYear.year &&
                  moment(el.date).month() + 1 == monthYear.month
              )
                ? "rgb(0, 169, 141,0.3)"
                : monthYear.year < new Date().getFullYear() ||
                  (monthYear.month < new Date().getMonth() + 1 &&
                    monthYear.year <= new Date().getFullYear()) ||
                  (monthYear.month == new Date().getMonth() + 1 &&
                    monthYear.year == new Date().getFullYear() &&
                    d <= new Date().getDate())
                ? "rgb(244, 81, 108,0.2)"
                : "",
              color: monthlyJournal.find(
                (el) =>
                  moment(el.date).date() === d &&
                  moment(el.date).year() === monthYear.year &&
                  moment(el.date).month() + 1 === monthYear.month
              )
                ? "rgb(0, 169, 141)"
                : monthYear.year < new Date().getFullYear() ||
                  (monthYear.month < new Date().getMonth() + 1 &&
                    monthYear.year <= new Date().getFullYear()) ||
                  (monthYear.month == new Date().getMonth() + 1 &&
                    monthYear.year == new Date().getFullYear() &&
                    d <= new Date().getDate())
                ? "rgb(244, 81, 108)"
                : "",
              minHeight: "80px",
            }}
          >
            {" "}
            <h6>{d}</h6>
            {monthYear.year < new Date().getFullYear() ||
            (monthYear.month < new Date().getMonth() + 1 &&
              monthYear.year <= new Date().getFullYear()) ||
            (monthYear.month == new Date().getMonth() + 1 &&
              monthYear.year == new Date().getFullYear() &&
              d <= new Date().getDate()) ? (
              <>
                {" "}
                {!user.checkoutId &&
                checkouts.find(
                  (ch) =>
                    ch.name != "TEST" &&
                    !monthlyJournal.find((j) => j.checkoutId == ch.id)
                ) &&
                monthlyJournal.find(
                  (el) =>
                    moment(el.date).date() == d &&
                    moment(el.date).year() == monthYear.year &&
                    moment(el.date).month() + 1 == monthYear.month
                ) ? (
                  <button
                    onClick={(e) => setshowCheckouts((prev) => (prev ? 0 : d))}
                    style={{
                      background: "#fff",
                      padding: "5px 10px",
                      color: "#232",

                      borderRadius: "5px",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    Détails{" "}
                    <IoAlertCircle size="20px" color="rgb(244, 81, 108)" />
                  </button>
                ) : (
                  ""
                )}
                <button
                  onClick={(e) => {
                    settransactions([]);
                    fetchTransactions(d);
                    setshow((prev) => (prev == d ? 0 : d));
                  }}
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    background: "#fff",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    lineHeight: "45px",
                    fontSize: "20px",
                  }}
                >
                  <IoExpandOutline />
                </button>
                {showCheckouts == d ? (
                  <ListJournal
                    close={() => setshowCheckouts(0)}
                    checkouts={checkouts}
                    data={monthlyJournal.filter(
                      (el) => moment(el.date).date() == d
                    )}
                  />
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </div>
        )}
      />
      <ListTransactions
        show={show}
        verify={
          monthlyJournal.find(
            (el) =>
              moment(el.date).date() == show &&
              moment(el.date).year() == monthYear.year &&
              moment(el.date).month() + 1 == monthYear.month
          ) || !user.checkoutId
            ? null
            : verify
        }
        close={() => setshow(0)}
        data={transactions}
      />
    </div>
  );
}
